import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Global, css, } from '@emotion/react';
const globalStyles = css `
  @font-face {
    font-family: 'Chronicle Display';
    font-style: normal;
    font-weight: 400;
    src: url('https://assets.minted.com/raw/upload/v1698100413/ChronicleDisp-Semibold.otf') format('opentype');
  }

  @font-face {
    font-family: 'Chronicle Display';
    font-style: italic;
    font-weight: 500;
    src: url('https://assets.minted.com/raw/upload/v1697743114/Minted_Onsite_Assets/2023/LP/ChronicleDisp-SemiboldItal.otf') format('opentype');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 400;
    src: url('https://assets.minted.com/raw/upload/Minted_Onsite_Assets/2023/LP/Gotham-Book.otf') format('opentype');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 500;
    src: url('https://assets.minted.com/raw/upload/Minted_Onsite_Assets/2023/LP/Gotham-Medium.otf') format('opentype');
  }
`;
const GlobalStyles = () => _jsx(Global, { styles: globalStyles });
export { GlobalStyles };
